// extracted by mini-css-extract-plugin
module.exports = {"iconEffect":"uS","iconInPlayer":"uT"};